/**
 * ContentSkeleton
 *
 * Shimmer placeholder for the server-search results section of the Cmd-K
 * palette, shown while the first page of ranked results is in flight. Each row is
 * sized to match a real {@link SearchResultItem}: a 32×32 icon tile plus a
 * two-line title/snippet column.
 *
 * Purely decorative — search status is announced by a separate ARIA live
 * region, so this is `aria-hidden` to keep screen readers from reading out a
 * meaningless stack of placeholders.
 */

import { HStack, Skeleton, VStack } from '@chakra-ui/react';

interface ContentSkeletonProps {
  /** Number of placeholder rows to render. Defaults to 2. */
  rows?: number;
}

export function ContentSkeleton({ rows = 2 }: ContentSkeletonProps) {
  return (
    <VStack spacing={0} align="stretch" aria-hidden="true">
      {Array.from({ length: rows }, (_, i) => (
        <HStack key={i} px={3} py={3} spacing={3} w="100%" align="center">
          <Skeleton boxSize="32px" borderRadius="md" flexShrink={0} />
          <VStack flex={1} minW={0} spacing={1.5} align="stretch">
            <Skeleton height="14px" width="55%" borderRadius="sm" />
            <Skeleton height="10px" width="80%" borderRadius="sm" />
          </VStack>
        </HStack>
      ))}
    </VStack>
  );
}
